const CODE_SELECTOR = '.rich-text-content pre > code[class*="language-"]';
const EDITOR_SELECTOR = '[data-component="textarea-editor"]';

let prismLoader = null;

function getPrism() {
    return window.Prism || null;
}

function markCodeBlock(codeElement) {
    codeElement.setAttribute('data-prism-processed', 'true');
    const pre = codeElement.closest('pre');
    if (pre) {
        pre.setAttribute('data-prism-processed', 'true');
    }
}

function isInsideEditor(element) {
    return Boolean(element?.closest?.(EDITOR_SELECTOR));
}

function highlightWithin(root = document) {
    const prism = getPrism();
    if (!prism) {
        return;
    }

    if (root !== document && isInsideEditor(root)) {
        return;
    }

    const nodes = [];
    if (root.matches?.(CODE_SELECTOR)) {
        nodes.push(root);
    }

    root.querySelectorAll?.(CODE_SELECTOR).forEach((node) => {
        nodes.push(node);
    });

    nodes.forEach((codeElement) => {
        if (isInsideEditor(codeElement)) {
            return;
        }

        if (codeElement.getAttribute('data-prism-processed') === 'true') {
            return;
        }

        prism.highlightElement(codeElement);
        markCodeBlock(codeElement);
    });
}

function loadPrismCSS() {
    if (document.getElementById('prismThemeCss')) {
        return;
    }

    const theme = document.body.getAttribute('data-bs-theme') || localStorage.getItem('theme') || 'light';
    const link = document.createElement('link');
    link.id = 'prismThemeCss';
    link.rel = 'stylesheet';
    link.href = `/assets/vendor/prism/prism-${theme}.css`;
    document.head.appendChild(link);

    new MutationObserver(() => {
        const newTheme = document.body.getAttribute('data-bs-theme') || 'light';
        link.href = `/assets/vendor/prism/prism-${newTheme}.css`;
    }).observe(document.body, { attributes: true, attributeFilter: ['data-bs-theme'] });
}

function loadPrism() {
    if (window.Prism) {
        return Promise.resolve(window.Prism);
    }
    if (!prismLoader) {
        prismLoader = import('../vendor/prism.js').then(() => {
            loadPrismCSS();
            return window.Prism;
        });
    }
    return prismLoader;
}

function startMutationObserver() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== Node.ELEMENT_NODE) {
                    return;
                }

                if (isInsideEditor(node)) {
                    return;
                }

                highlightWithin(node);
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

function initSyntaxHighlighting() {
    if (document.querySelector(CODE_SELECTOR)) {
        loadPrism()
            .then(() => {
                highlightWithin(document);
                startMutationObserver();
            })
            .catch((error) => {
                console.error(error);
            });
        return;
    }

    const earlyObserver = new MutationObserver(() => {
        if (!document.querySelector(CODE_SELECTOR)) {
            return;
        }
        earlyObserver.disconnect();
        loadPrism()
            .then(() => {
                highlightWithin(document);
                startMutationObserver();
            })
            .catch((error) => {
                console.error(error);
            });
    });

    earlyObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSyntaxHighlighting, { once: true });
} else {
    initSyntaxHighlighting();
}
